import { isEmpty, isObject } from 'lodash';

const DEFAULT_ERROR_MESSAGE = 'Something went wrong on our side. Please try again later.';
const STRING_PLACEHOLDER = '%s'

const getArrayErrorMessage = (responseError, field = '') => {
  if (!isObject(responseError)) {
    return DEFAULT_ERROR_MESSAGE;
  }

  if (!isEmpty(responseError?.errors) && field) {
    return responseError.errors[0]?.[field] || DEFAULT_ERROR_MESSAGE;
  }

  if (!isEmpty(responseError?.errors) && responseError?.errorMessage === 'Invalid request') {
    const error = responseError?.errors[0]
    if (error?.type === 'HINT')
      return error
    else if (error?.message?.includes(STRING_PLACEHOLDER))
      return error.message.replace(STRING_PLACEHOLDER, error?.name)
    else
      return error?.message || DEFAULT_ERROR_MESSAGE;
  }

  return responseError?.errorMessage || responseError?.message || DEFAULT_ERROR_MESSAGE;
};
export default getArrayErrorMessage;
